import React from 'react';
import { Button } from 'finform';
import { useAppDispatch, useAppSelector } from '#app/hooks/useAppStore';
import { setSpendingBudgetModalVisible } from '#app/actions/spendingBudget';

/**
 * Кнопка открытия модалки бюджета расходов.
 * Состояние модалки хранится в Redux (spendingBudget.modalVisible),
 * сама модалка рендерится глобально в CabinetLayout (SpendingBudgetModal).
 */
const SpendingBudget = ({ buttonStyle, id }) => {
  const dispatch = useAppDispatch();
  const i18n = useAppSelector((state) => state.i18n);
  const buttonId = id || 'spending-budget-trigger';
  return (
    <Button
      type="transparent"
      style={buttonStyle ?? { margin: '0 0 0 35px' }}
      id={buttonId}
      onClick={() => dispatch(setSpendingBudgetModalVisible(true))}
    >
      {i18n?.incomeOutcome?.configBudget}
    </Button>
  );
};

export { SpendingBudget };
export default SpendingBudget;
